import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=083f5ab8&"
import script from "./ReportPage.vue?vue&type=script&lang=js&"
export * from "./ReportPage.vue?vue&type=script&lang=js&"
import style0 from "../styles/reports.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports